module.exports = __webpack_public_path__ + "assets/img/DB-Results-2-Service-Page.654fd088.jpg";